import { Button, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const NewVersionPopup = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    open: false,
    worker: null,
  });

  const addEventHandlers = useCallback(
    reg => {
      setState(s => ({ ...s, worker: reg.active }));

      let newWorker;
      reg.addEventListener('updatefound', () => {
        newWorker = reg.installing;
        setState(s => ({ ...s, worker: newWorker }));

        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          switch (newWorker?.state) {
            case 'installed':
              if (navigator.serviceWorker.controller) {
                // eslint-disable-next-line no-console
                console.log('New content is available; please refresh.');
                setState(s => ({ ...s, open: true }));
                // eslint-disable-next-line no-console
              } else console.log('Content is cached for offline use.');
              break;

            case 'activated':
              if (window.self !== window.top) {
                // In an iframe → refresh the top window
                window.top.location.reload();
              } else {
                // Not in an iframe → normal reload
                window.location.reload();
              }
              break;
            default:
          }
        });
      });
    },
    [setState],
  );

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration('./service-worker.js').then(reg => {
        if (reg) addEventHandlers(reg);
        else navigator.serviceWorker.register('./service-worker.js').then(reg => addEventHandlers(reg));
      });
    }
  }, [addEventHandlers]);

  const isInIframe = window.self !== window.top;

  if (isInIframe) return null;

  return ReactDOM.createPortal(
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={state.open}
      onClose={(_, reason) => setState({ ...state, open: reason === 'clickaway' ? state.open : false })}
      message={t('newVersionAvailable')}
      action={
        <Button
          color="secondary"
          size="small"
          onClick={() => {
            // eslint-disable-next-line no-console
            if (!state?.worker) console.warn('No reference to service worker to post messages to.');
            else {
              state.worker.postMessage({ type: 'SKIP_WAITING' });
            }
          }}>
          {t('refresh')}
        </Button>
      }
    />,
    document.getElementById('refresh-banner') || document.body,
  );
};

export default NewVersionPopup;
